export default __webpack_public_path__ + "static/media/image-8.67dd5900.jpeg";